var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.038,
    height: 12.73,
    viewBox: "0 0 8.038 12.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-ios-arrow-right",
    "data-name": "Icon ion-ios-arrow-right",
    d: "M11.25,7.461l.759-.711,6.279,5.865L12.009,18.48l-.759-.707,5.517-5.158Z",
    transform: "translate(-10.75 -6.25)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightAccount);
export default __webpack_public_path__ + "static/media/arrowRightAccount.bd5d7a7706215994c16e0456c20bef1f.svg";
export { ForwardRef as ReactComponent };